import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {GlobalsService} from "@services/globals.service";

@Injectable()
export class InterceptorInterceptor implements HttpInterceptor {
  api= "api"
  constructor(private  _globals: GlobalsService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const {url} = request;
    const isApi = url.includes(this.api)
    const token = this._globals.token;

    if (isApi) {
      const clone = request.clone(
        {
          headers: request.headers.append('Authorization', `Bearer ${token}`)
        }
      )
      return next.handle(clone);
    }
    return next.handle(request);
  }
}
